import Users from '@/api/users'
import moment from "moment";
export default {
  data () {
    return {
      defaultFacetsNumber: 3

    }
  },

  methods: {
    modifySearch () {
      this.queryParams.page = undefined
      for (const prop in this.facets) {
        this.facets[prop].number = this.defaultFacetsNumber
        if (this.queryParams.hasOwnProperty(`${prop}Number`)) {
          this.$delete(this.queryParams, `${prop}Number`)
        }
        this.facets[prop].checked = []
        if (this.queryParams.hasOwnProperty(`${prop}Facet`)) {
          this.$delete(this.queryParams, `${prop}Facet`)
        }
      }
      this.updateUrl({ results: undefined })
    },

    updateFacets (key) {
      this.queryParams[`${key}Facet`] = this.facets[key].checked
      this.$delete(this.queryParams, `${key}Number`)
      this.updateUrl()
    },

    putQueryParamsInFacets () {
      for (const prop in this.facets) {
        if (this.queryParams.hasOwnProperty(`${prop}Number`)) {
          this.facets[prop].number = Number(this.queryParams[`${prop}Number`])
        } else {
          this.facets[prop].number = this.defaultFacetsNumber
        }

        if (this.queryParams.hasOwnProperty(`${prop}Facet`)) {
          if (Array.isArray(this.queryParams[`${prop}Facet`])) {
            this.facets[prop].checked = this.queryParams[`${prop}Facet`]
          } else {
            this.facets[prop].checked = Array(this.queryParams[`${prop}Facet`])
          }
        } else {
          this.facets[prop].checked = []
        }
      }
    }
  },

  mounted() {
    const searchId = this.$route.query.searchId
    if (searchId) {
      Users.updateSearch({id: searchId, last_search: moment().format()})
    }
  }
}
